import { vendorAddressEditFormSchema } from './update-form.js';
import { updateVendorAddressInputSchema } from './update-input.js';
export function toUpdateVendorAddressInput(values, vendorName) {
    const parsed = vendorAddressEditFormSchema.parse(values);
    const input = {};
    if (vendorName !== undefined) {
        input.name = vendorName;
    }
    if (parsed.addressName !== undefined) {
        input.addressName = parsed.addressName;
    }
    if (parsed.typeId !== undefined && parsed.typeId.trim() !== '') {
        input.typeId = Number(parsed.typeId);
    }
    if (parsed.address !== undefined) {
        input.address = parsed.address;
    }
    if (parsed.city !== undefined) {
        input.city = parsed.city ?? null;
    }
    if (parsed.stateId !== undefined) {
        input.stateId = parsed.stateId ?? null;
    }
    if (parsed.countryId !== undefined) {
        input.countryId = parsed.countryId ?? null;
    }
    if (parsed.zip !== undefined) {
        input.zip = parsed.zip ?? null;
    }
    // The resolver already force-clears defaultFlag server-side whenever the row's final type
    // isn't shipping-eligible (see update-vendor-address.ts) — no need to pre-empt that here.
    if (parsed.defaultFlag !== undefined) {
        input.defaultFlag = parsed.defaultFlag;
    }
    return updateVendorAddressInputSchema.parse(input);
}
//# sourceMappingURL=update-mapper.js.map